<ng-container *ngIf="isOpen()">
  <div class="pf-overlay" (click)="close()"></div>

  <div class="pf-panel" role="dialog" aria-label="Change Password">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" (keydown.enter)="$event.preventDefault()">
      <header class="pf-head">
        <div class="pf-head-ic">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <div class="pf-head-txt">
          <h2>Change Password</h2>
          <p class="pf-sub">Use at least 8 characters with a mix of letters, numbers &amp; symbols</p>
        </div>
        <button type="button" class="pf-close" (click)="close()" title="Close" aria-label="Close">✕</button>
      </header>

      <div class="pf-body">
        <div class="pf-grid">
          <div class="pf-field">
            <label for="oldPassword">Old Password</label>
            <div class="pf-pw">
              <input id="oldPassword" [type]="showOld ? 'text' : 'password'" formControlName="old_password"
                     placeholder="Old Password" autocomplete="current-password"
                     [class.pf-invalid]="(isLoading || cp.old_password.errors?.apiError) && cp.old_password.invalid"/>
              <button type="button" class="pf-eye" (click)="showOld = !showOld" title="Show / hide"
                      [attr.aria-label]="showOld ? 'Hide password' : 'Show password'">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </button>
            </div>
            <div class="pf-err" *ngIf="(isLoading || cp.old_password.errors?.apiError) && cp.old_password.invalid">
              <span *ngIf="cp.old_password.errors?.required">Old password is required.</span>
              <span *ngIf="cp.old_password.errors?.minlength">Old password must be at least 6 characters.</span>
              <span *ngIf="cp.old_password.errors?.maxlength">Old password must be less than 25 characters.</span>
              <span *ngIf="cp.old_password.errors?.apiError">{{ cp.old_password.errors?.apiError }}</span>
            </div>
          </div>

          <div class="pf-field">
            <label for="newPassword">New Password</label>
            <div class="pf-pw">
              <input id="newPassword" [type]="showNew ? 'text' : 'password'" formControlName="new_password"
                     placeholder="New Password" autocomplete="new-password"
                     [class.pf-invalid]="(isLoading || cp.new_password.errors?.apiError) && cp.new_password.invalid"/>
              <button type="button" class="pf-eye" (click)="showNew = !showNew" title="Show / hide"
                      [attr.aria-label]="showNew ? 'Hide password' : 'Show password'">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </button>
            </div>
            <div class="pf-strength" *ngIf="cp.new_password.value">
              <div class="pf-strength-bars">
                <span *ngFor="let bar of [1, 2, 3, 4]" [style.background]="bar <= strength ? strengthColor : ''"></span>
              </div>
              <div class="pf-strength-label" [style.color]="strengthColor">{{ strengthLabel }}</div>
            </div>
            <div class="pf-err" *ngIf="(isLoading || cp.new_password.errors?.apiError) && cp.new_password.invalid">
              <span *ngIf="cp.new_password.errors?.required">New password is required.</span>
              <span *ngIf="cp.new_password.errors?.minlength">New password must be at least 6 characters.</span>
              <span *ngIf="cp.new_password.errors?.maxlength">New password must be less than 25 characters.</span>
              <span *ngIf="cp.new_password.errors?.apiError">{{ cp.new_password.errors?.apiError }}</span>
            </div>
          </div>

          <div class="pf-field pf-full">
            <label for="confirmPassword">Confirm Password</label>
            <div class="pf-pw">
              <input id="confirmPassword" [type]="showConfirm ? 'text' : 'password'" formControlName="confirm_password"
                     placeholder="Confirm Password" autocomplete="new-password" [class.pf-invalid]="mismatch"/>
              <button type="button" class="pf-eye" (click)="showConfirm = !showConfirm" title="Show / hide"
                      [attr.aria-label]="showConfirm ? 'Hide password' : 'Show password'">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </button>
            </div>
            <div class="pf-err" *ngIf="mismatch">Passwords don't match.</div>
            <div class="pf-err" *ngIf="!mismatch && (isLoading || cp.confirm_password.errors?.apiError) && cp.confirm_password.invalid">
              <span *ngIf="cp.confirm_password.errors?.required">Confirm password is required.</span>
              <span *ngIf="cp.confirm_password.errors?.minlength">Confirm password must be at least 6 characters.</span>
              <span *ngIf="cp.confirm_password.errors?.maxlength">Confirm password must be less than 25 characters.</span>
              <span *ngIf="cp.confirm_password.errors?.apiError">{{ cp.confirm_password.errors?.apiError }}</span>
            </div>
          </div>
        </div>
      </div>

      <footer class="pf-foot">
        <button type="button" class="btn-secondary btn-sm" (click)="close()">Cancel</button>
        <button type="submit" class="btn-primary btn-sm" [disabled]="!canSave || submitted">
          {{ submitted ? 'Updating…' : 'Update Password' }}
        </button>
      </footer>
    </form>
  </div>
</ng-container>
